import { relocationPalletEpcValidate } from "../../application/dtos/relocation_pallet_epc_validate";

export class relocationPalletEpcEntity {
    constructor({ location, client, products }){
        this.location = location;
        this.client = client;
        this.products = products;
    }

    isValid() {
        return relocationPalletEpcValidate(this);
    }
}